"use strict";
require('es6-promise').polyfill()

import ajaxInterceptor from './ajax-http-interceptor'
import Vue from 'vue'
import VueCookie from 'vue-cookie'

import EventBus from '../../vue/events/event-bus'

Vue.use(VueCookie)

Vue.mixin({
	data () {
		return {
			_ : _,
      langSelected: window._cookie
		}
	},
})

import Core from '@/vue/apps/core/core.vue'
export default new Vue({
  components: { Core: Core },
})



// WEBPACK FOOTER //
// ./resources/wob/js/core/core.js